import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../authentication/authContext';

const ProtectedRoute = ({ element, redirectTo = "/home" }) => {
  const { isAuthenticated } = useAuth();  

  if (isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }

  return element;
};

export default ProtectedRoute;
